import { BikeLabelOrderIndexStepEnum, BikeLabelOrderStepEnum, BikeLabelStepType } from "./types"

/**
 * BikeLabelStep
 *
 */
export const bikeLabelStep: BikeLabelStepType = {
	[BikeLabelOrderStepEnum.COMMAND_STEP]: {
		label: "label.command",
		title: "title.command",
		index: BikeLabelOrderIndexStepEnum.COMMAND_STEP,
		back: true,
	},
	[BikeLabelOrderStepEnum.EXPEDITION_STEP]: {
		label: "label.expedition",
		title: "title.expedition",
		index: BikeLabelOrderIndexStepEnum.EXPEDITION_STEP,
		back: true,
	},
	[BikeLabelOrderStepEnum.SUMMARY_STEP]: {
		label: "label.summary",
		title: "title.summary",
		index: BikeLabelOrderIndexStepEnum.SUMMARY_STEP,
		back: true,
	},
	[BikeLabelOrderStepEnum.CONFIRMATION_STEP]: {
		label: "label.confirmation",
		title: "title.confirmation",
		index: BikeLabelOrderIndexStepEnum.CONFIRMATION_STEP,
		back: false,
	},
}

//Query Step name
export const QUERY_LABEL_ORDER_STEP = "step"
//Default Query Params
export const defaultQueryParamsBikeLabelOrder = {
	[QUERY_LABEL_ORDER_STEP]: BikeLabelOrderIndexStepEnum.COMMAND_STEP,
} as const

const bikeLabelOrderIndexStepEnumLength = Object.keys(BikeLabelOrderIndexStepEnum).filter((key) =>
	isNaN(Number(key))
).length

const BikeLabelOrderIndexStepEnumLength = bikeLabelOrderIndexStepEnumLength

export enum LimitStepEnum {
	MAX_LIMIT_STEP = BikeLabelOrderIndexStepEnumLength,
	MIN_LIMIT_STEP = 1,
}

export const CENT = 100

export enum QuantityLimitEnum {
	LOWER_LIMIT_QUANTITY = 0,
	MAX_LIMT_QUANTITY = 99,
}
export const PREFIX_HANDLE = "handleTo"
export const NO_ACTIVE_ORDER = "0"
export const UNDERSCORE = "_"
export const EURO = "€"
export const ORDER_LINE = "order_lines"
